export const NotFound = () => <>Page not found</>;